import { jsx as _jsx } from "react/jsx-runtime";
import { EditButton, useRecordContext } from "react-admin";
import React from "react";
export const ConditionalEditButton = ({ isDisabled, ...props }) => {
    const record = useRecordContext();
    return _jsx(EditButton, { ...props, disabled: isDisabled(record) });
};
